import { Container, Row, Col, Divider } from '@geberit/gdds';

// styles
import styles from './border.module.scss';

// utils
import { buildSize, gridSizes } from 'utils/gridSize';
import { useGroup } from 'utils/hooks/use-group';

export function SectionClosingLine() {
  const isGroup = useGroup();

  return (
    <Container
      maxContentWidth={buildSize(gridSizes[isGroup ? 'full' : 'gddsFullGrid'])}
      className={styles.sectionClosingLine}
    >
      <Row>
        <Col size={[4, 8, 12]}>
          <Divider alignment="horizontal" />
        </Col>
      </Row>
    </Container>
  );
}
